var rating_text = {};
var rating_average = 0;
var rating_wrapper = null;

function ratingAverage(rating_wrapper) {
    var $rating_average = rating_wrapper.find('#ratingAverage');

    if ($rating_average.length) {
        $rating_average.empty().text(rating_text['vote.average']);
    } else {
        rating_wrapper.append('<span id="ratingAverage" class="invisible-text" aria-live="polite">' + rating_text['vote.average'] + '</span>');
    }
}

var openModaleRecipeIngredientsAddToCart = function ($modalTrigger, isAddingAll) {
    var containerModale = isAddingAll ? $('#addToCartAllIngredientsModaleContainer').find('.remodal') : $modalTrigger.parent().siblings('[id^=addToCartIngredientModaleContainer]').find('.remodal') ;
    var modaleIngredients = containerModale.find('.remodal-add-to-cart-ingredient');

    // Open or reopen the modale Add to cart for an ingredient
    var initSlider = function (containerSlider) {
        if (Revealizr.isDesktopSize) {
            $('.see-all-product-tile').remove();
        }

        updateQtyIncrementerButtonsState();
        showProductsPreviousErrors();
    };

    // Call by ajax hybris to get the list of products addeable to the cart
    var bindIngredientModaleButtonBox = function () {
        $("[id^=button-ingredients-add-to-cart-]").on('click', function () {
            const triggerIngredient = $(this);
            const containerIngredientCarousel = $(triggerIngredient.data("target-toggle"));
            const modaleAddToCartFromIngredient = $('.remodal-add-to-cart-ingredient');

            // Call only if a previous call has not been done before = products-listing exists
            if (containerIngredientCarousel.find(".productsIngredientList").length == 0) {
                TINK.inProgress(modaleAddToCartFromIngredient);
                TINK.sessionAjax({
                    url: addIngredientsToCartAjaxUrl + "/update",
                    data: JSON.stringify({
                        hybrisKeywords: $(this).data("hybris-keywords"),
                        metroShopCategory: $(this).data("metro-shop-category")
                    }),
                    type: 'post',
                    contentType: 'application/json; charset=utf-8',
                    success: function (data) {
						containerIngredientCarousel.append(data);
						triggerIngredient.addClass('is_active');
                        containerIngredientCarousel.addClass('is_active');
                        initSlider(containerIngredientCarousel);
                        productTileSlick();
                        showProductsPreviousErrors();
                    },
                    error: function (jqXHR) {
                        TINK.handleAjaxError(jqXHR);
                    },
                    complete: function () {
                        TINK.stopProgress(modaleAddToCartFromIngredient);
                    }
                });
            } else if (triggerIngredient.hasClass('is_active')) {
                triggerIngredient.removeClass('is_active');
                containerIngredientCarousel.removeClass('is_active');
            } else {
                triggerIngredient.addClass('is_active');
                containerIngredientCarousel.addClass('is_active');
            }
        });
	};

    // If the modale is already created we don't call again the backend, just reopen it
    if (modaleIngredients.length > 0) {
        containerModale.remodal().open();
        productTileSlick();
	}

    else {
        TINK.inProgress($("#Ingredients"));
        // Prepare all informations needed to create the modale of hybris search products
		const ingredientsData = [];
		const $dataHolder = ( isAddingAll ) ? $(".addto-cart-ingredient[data-hybris-keywords != ''][data-hybris-keywords]") : $modalTrigger;

        $dataHolder.each(function () {
            ingredientsData.push({
                name: $(this).data("ingredient-name"),
                measure: $(this).data("measure"),
                hybrisKeywords: $(this).data("hybris-keywords"),
                metroShopCategory: $(this).data("metro-shop-category")
            });
        });

        TINK.sessionAjax({
            url: addIngredientsToCartAjaxUrl,
            data: JSON.stringify(ingredientsData),
            type: 'post',
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
				$modalTrigger.addClass('is_active');
				containerModale.append(data);

				containerModale.modalActionsExceptions({
					ctaAddToCart : '[onclick*="addProductToCart"]',
					ctaAddToCartStarter : '.addToCartStarter',
					tabClose : '.remodal-add-to-cart-ingredient',
					tabsType : 'modal-ingredients'
				});

                if (isAddingAll) {
                    containerModale.find('[data-tab-close]:not(.notification__close)').attr('data-tabs-type', 'modal-ingredients');
                }
                containerModale.remodal().open();
				bindIngredientModaleButtonBox();
                initSlider(containerModale);
                productTileSlick();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.log( 'Fix me. I\'m supposed to handle errors' ); //handleError(jqXHR); jira : T4286-3060
                }
            },
            complete: function () {
                TINK.stopProgress($("#Ingredients"));
            }
        });
    }
};

var preventModaleFromClosingAfterAddToCartIfCartExists = function ($modalTrigger, isAddingAll) {
    if (isCartAvailable) {
        var containerModale = isAddingAll ? $('#addToCartAllIngredientsModaleContainer') : $modalTrigger.parent().siblings('[id^=addToCartIngredientModaleContainer]');
        var modaleIngredients = containerModale.find('.remodal-add-to-cart-ingredient');
        if (modaleIngredients.length > 0) {
            modaleIngredients.find('[onclick*="addProductToCart"]').removeAttr('data-tab-close');
        }
    }
};

jQuery(document).ready(function () {
    // Add one ingredient
    $(document).on('click', '.addto-cart-ingredient', function () {
        openModaleRecipeIngredientsAddToCart($(this), false);
        preventModaleFromClosingAfterAddToCartIfCartExists($(this), false);
    });

    // Add all ingredients
    $(document).on('click', '.addto-cart-all-ingredients', function () {
        openModaleRecipeIngredientsAddToCart($(this), true);
        preventModaleFromClosingAfterAddToCartIfCartExists($(this), true);
    });

    $('[data-is="time"]').each(function () {

        var elem = $(this),
            text_original = elem.text().split(':'),
            text_hour = text_original[0],
            text_minute = text_original[1];

        if (lang === 'en') {
            newtext = {
                'recipe.hour': '&nbsp;Hours&nbsp;',
                'recipe.minute': '&nbsp;Minutes&nbsp;'
            };
        } else {
            newtext = {
                'recipe.hour': '&nbsp;heures&nbsp;',
                'recipe.minute': '&nbsp;minutes&nbsp;'
            };
        }
        elem.html(text_hour + '<span aria-hidden="true">:</span><span class="invisible-text">' + newtext['recipe.hour'] + '</span>' + text_minute + '<span class="invisible-text">' + newtext['recipe.minute'] + '</span>');
    });

    $('#starRating').barrating({
        showSelectedRating: true,
        deselectable: true,
        hoverState: true,
        initialRating: ratingNumber,
        readonly: !ratingEnabled,
        onSelect: function (value) {
            $.ajax({
                type: "PUT",
                url: ratingBlockURL + '/' + recipeId + '/' + value,
                success: function () {

                    // Increment the number of votes
                    var $nbRatingVotes = $("#nbRatingVotes");
                    var nbVotes = parseInt($nbRatingVotes.text());

                    rating_average = rating_wrapper.find('.br-current-rating').text();

                    if (!isNaN(nbVotes)) {
                        nbVotes += 1;
                        $nbRatingVotes.text(nbVotes);
                        // Based on previous vote
                        $nbRatingVotes.find("+ span").text(nbVotes === 1 ? ' Vote' : ' Votes');
                    }

                    if (lang === 'en') {
                        rating_text = {
                            'vote.average': 'Vote average : ' + rating_average + ' stars',
                            'vote.star': 'star'
                        };
                    } else {
                        rating_text = {
                            'vote.average': 'Moyenne des votes : ' + rating_average + ' étoiles',
                            'vote.star': 'étoile'
                        };
                    }

                    ratingAverage(rating_wrapper);
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });

            $('#starRating').barrating('readonly', true);
        },

        onCreate: function () {
            var rating_widget = $(this)[0].$elem.next('.br-widget');
            rating_wrapper = rating_widget.closest('.rh--rating');
            rating_average = rating_wrapper.find('.br-current-rating').text();
            var rating_star_button = rating_widget.find('.br-star');

            if (lang === 'en') {
                rating_text = {
                    'vote.average': 'Vote average : ' + rating_average + ' stars',
                    'vote.star': 'star'
                };
            } else {
                rating_text = {
                    'vote.average': 'Moyenne des votes : ' + rating_average + ' étoiles',
                    'vote.star': 'étoile'
                };
            }

            ratingAverage(rating_wrapper);

            rating_star_button.each(function (index) {
                var title = $(this).attr('title');
                if (index === 0) {
                    $(this).attr({
                        'title': title + ' ' + rating_text['vote.star'],
                        'aria-controls': 'ratingAverage'
                    });
                } else {
                    $(this).attr({
                        'title': title + ' ' + rating_text['vote.star'] + 's',
                        'aria-controls': 'ratingAverage'
                    });
                }
            });
        }
    });

});

const showRecipeIngrediends = function () {

    $('#Preparation').hide();
    $('#Ingredients').fadeIn();
    $('.tabs--recipe .tab').toggleClass('is_active');
}

const showRecipePreparation = function () {
    $('#Ingredients').hide();
    $('#Preparation').fadeIn();
    $('.tabs--recipe .tab').toggleClass('is_active');
}
